define('controllers/modules/calendar/item/personal-data',[
    // Libs
    'backbone', 'utils',
    // parent
    'controllers/modules/calendar/abstract-item',
    // Models
    'models/calendar/item/personal-data',
    // Views | Layout
    'views/modules/calendar/personal-data/item/personal-data-panel',
], function(
    // Libs
    Backbone, U,
    // parent
    AbstractCalendarItemCtrl,
    // Models
    MPersonalData,
    // Views | Layout
    VPersonalDataPanel
) {

    var CalendarPersonalDataCtrl = AbstractCalendarItemCtrl.extend({

        lazyInit: function() {
            this.model = new MPersonalData();
            this.view = new VPersonalDataPanel({
                model: this.model,
                url: Backbone.history.getFragment(),
                role: this.role,
                group: this.group,
            });
            this.listenTo(this.view, 'back', this.onBack);

            return this.getLayout();
        },

    });

    return CalendarPersonalDataCtrl;

});

